import { Card } from "@redotech/arbiter/card";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import classNames from "classnames";
import { memo, type ReactNode } from "react";
import { SettingsHelpIcon } from "./settings-help-icon";
import * as css from "./settings-rows.module.css";

/** Bordered card of rows with dividers and an optional small heading. */
export const SettingsGroup = memo(function SettingsGroup({
  heading,
  helpText,
  action,
  flushDividers,
  children,
}: {
  heading?: string;
  helpText?: string;
  action?: ReactNode;
  flushDividers?: boolean;
  children: ReactNode;
}) {
  return (
    <Flex className={css.group} dir="column" gap="md" w="full">
      {heading && (
        <Flex align="center" gap="xl" justify="space-between" px="2xl">
          <Flex align="center" gap="sm">
            <Text fontSize="xs" fontWeight="medium" textColor="tertiary">
              {heading}
            </Text>
            {helpText && <SettingsHelpIcon size={14} text={helpText} />}
          </Flex>
          {action && <Flex shrink={0}>{action}</Flex>}
        </Flex>
      )}
      <Card
        borderColor="secondary"
        borderRadius="md"
        className={classNames(css.rowList, flushDividers && css.rowListFlush)}
        gap="none"
        noPadding
        overflow="hidden"
        w="full"
      >
        {children}
      </Card>
    </Flex>
  );
});
